import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';

const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Archived', label: 'Archived' },
];

const StatusEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ status: value }));
      if (validationErrors.status) {
        dispatch(clearValidationError('status'));
      }
    }
  };

  if (!contract) return null;

  // Default to 'Active' if status is not set (for backward compatibility)
  const currentStatus = contract.status || 'Active';

  return (
    <FormControl variant="outlined" size="small" error={!!validationErrors.status} sx={{ width: 220 }}>
      <InputLabel>Status</InputLabel>
      <Select
        value={currentStatus}
        onChange={(e) => handleChange(e.target.value)}
        label="Status"
        sx={{ backgroundColor: 'white' }}
      >
        {STATUS_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {validationErrors.status && (
        <FormHelperText>{validationErrors.status}</FormHelperText>
      )}
    </FormControl>
  );
};

export default StatusEditor;
